// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"MX","sortWrapper":"NX","shortCount":"OX","fullCount":"PX","countWrapper":"QX","hasSavedSearch":"RX","desktopSaveSearch":"SX"};